export default {
  productRemove: {
    id: 'product_remove',
    defaultMessage: 'Remove',
  },
}
